// lurik-frontend/src/presentation/pages/workspace/settings/security-section/components/UserList.tsx
import React from 'react';
import styled from 'styled-components';
import { IUser } from '../../../../../../application/models/IUser';

interface UserListProps {
  users: IUser[];
  twoFactorCompanyEnabled: boolean;
}

const UserListContainer = styled.div`
  background: white;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;

const UserListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const UserListTitle = styled.h4`
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

const UserCount = styled.span`
  background: #e3f2fd;
  color: #1976d2;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
`;

const UserTable = styled.div`
  border: 1px solid #e1e5e9;
  border-radius: 6px;
  overflow: hidden;
`;

const UserTableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 16px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-bottom: 1px solid #e1e5e9;
  font-weight: 600;
  font-size: 12px;
  color: #7f8c8d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const UserRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f3f4;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: #f8f9fa;
  }
`;

const UserCell = styled.div`
  font-size: 14px;
  color: #2c3e50;
  display: flex;
  align-items: center;
`;

const UserStatus = styled.span<{ enabled: boolean }>`
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  background-color: ${props => props.enabled ? '#d4edda' : '#f8d7da'};
  color: ${props => props.enabled ? '#155724' : '#721c24'};
  border: 1px solid ${props => props.enabled ? '#c3e6cb' : '#f5c6cb'};
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #7f8c8d;
`;

export const UserList: React.FC<UserListProps> = ({
  users,
  twoFactorCompanyEnabled
}) => {

  
  const activeUsers = users.filter((user: IUser) => user.status === true); 

  if (!users || users.length === 0) {
    return (
      <UserListContainer>
        <EmptyState>
          <p>Nenhum usuário encontrado</p>
        </EmptyState>
      </UserListContainer>
    );
  }

  return (
    <UserListContainer>
      <UserListHeader>
        <UserListTitle>Usuários da Empresa</UserListTitle>
        <UserCount>{activeUsers.length} usuários ativos</UserCount>
      </UserListHeader>
      
      <UserTable>
        <UserTableHeader>
          <div>Nome</div>
          <div>Email</div>
          <div>Status 2FA</div>
        </UserTableHeader>
        
        {activeUsers.map((user) => (
          <UserRow key={user.id}>
            <UserCell>{user.name}</UserCell>
            <UserCell>{user.email}</UserCell>
            <UserCell>
              <UserStatus enabled={user.twoFactorEnabled}>
                {user.twoFactorEnabled ? 'Ativado' : 'Desativado'}
              </UserStatus>
            </UserCell>
          </UserRow>
        ))}
      </UserTable>
    </UserListContainer>
  );
};